import { Injectable, inject } from '@angular/core';
import { CanActivate, CanActivateChild, CanMatch, Router, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanMatch {
  private authService = inject(AuthService);
  private router = inject(Router);

private checkAuthState(state?: RouterStateSnapshot,segments?: UrlSegment[]): Observable<boolean> {
  return this.authService.ensureAuthenticated().pipe(
    take(1),
    map(isAuthenticated => {
      if (!isAuthenticated) {
        const navUrl = this.router.getCurrentNavigation()?.extractedUrl?.toString();
        const windowUrl = typeof window !== 'undefined' ? window.location.pathname : '';
        const segmentUrl = `/${segments?.map(segment => segment.path).join('/') || ''}`;
        const requestedUrl = state?.url || navUrl || windowUrl || segmentUrl;

        const userType = this.authService.getUserType();

        // Determine the login page from the requested URL.
        const isCrmRoute = requestedUrl.includes('/crm') || userType === 'crm';

        if (isCrmRoute) {
          this.router.navigate(['/login']);
        } else {
          this.router.navigate(['/agentlogin']);
        }
        return false;
      }
      return true;
    })
  );
}

canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkAuthState(state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkAuthState(state);
  }

  // ✅ Modernized: canMatch replaces the deprecated canLoad hook natively
  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this.checkAuthState(undefined, segments);
  }
}
